import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  CatCicloVida,
  CatNivelSupervision,
  CatTipoImpacto,
} from "../shared/model/iso42001/inventario-ia.model";

export interface CatalogoIARes {
  ciclosVida?: CatCicloVida[];
  nivelesSupervision?: CatNivelSupervision[];
  tiposImpacto?: CatTipoImpacto[];
  idGenerado?: number;
  codigoError?: string;
  mensajeError?: string;
}

@Injectable({
  providedIn: "root",
})
export class CatalogosIAService {
  constructor(private http: HttpClient) {}

  // ---- Ciclo de Vida ----
  listarCiclos(): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_CICLO_LISTAR, {});
  }
  guardarCiclo(cicloVida: CatCicloVida): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_CICLO_GUARDAR, { cicloVida });
  }
  cambiarEstatusCiclo(id: number, estatus: string): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_CICLO_ESTATUS, { id, estatus });
  }

  // ---- Nivel de Supervisión ----
  listarNiveles(): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_NIVEL_LISTAR, {});
  }
  guardarNivel(nivelSupervision: CatNivelSupervision): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_NIVEL_GUARDAR, { nivelSupervision });
  }
  cambiarEstatusNivel(id: number, estatus: string): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_NIVEL_ESTATUS, { id, estatus });
  }

  // ---- Tipo de Impacto ----
  listarImpactos(): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_IMPACTO_LISTAR, {});
  }
  guardarImpacto(tipoImpacto: CatTipoImpacto): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_IMPACTO_GUARDAR, { tipoImpacto });
  }
  cambiarEstatusImpacto(id: number, estatus: string): Observable<CatalogoIARes> {
    return this.http.post<CatalogoIARes>(UrlConstantes.ISO42001_ADMIN_IMPACTO_ESTATUS, { id, estatus });
  }
}
